var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$statsigState.loading)?_c('BaseLoader',{attrs:{"size":"xl"}}):(_vm.$statsigState.initialized && _vm.isFeatureEnabled)?_c('KiosksEnhanced'):_c('Kiosks')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }